import { createActionGroup } from '@ngrx/store';

export const UserNewsletterActions = createActionGroup({
  source: 'User Newsletter',
  events: {}
});
